import Timeline from './Timeline';
export default Timeline;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/timeline/index.js
// module id = 845
// module chunks = 0